'use client'

import { useMediaQuery } from '@segway/core'

import { useRouter } from '@/i18n/navigation'

import { Arrow } from '../icons'

const MobileHeader = ({ name }: { name: string }) => {
  const router = useRouter()
  const responsive = useMediaQuery()
  return (
    <>
      {responsive && !responsive.xl && (
        <div className="relative flex h-12 items-center justify-center">
          <span
            className="absolute left-[10px] top-4"
            onClick={() => {
              router.back()
            }}>
            <Arrow rotate={180} />
          </span>
          <h1 className="text-lg">{name}</h1>
        </div>
      )}
    </>
  )
}

export default MobileHeader
